import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from 'src/app/services/config.service';
import { HelperFunctions } from 'src/app/services/helper-functions';
import { PartnerServicesService } from 'src/app/services/partner-service/partner-services.service';
import { UserManagerService } from 'src/app/services/user-manager/user-manager.service';

@Component({
  selector: 'app-image-container',
  templateUrl: './image-container.component.html',
  styleUrls: ['./image-container.component.scss']
})
export class ImageContainerComponent implements OnInit {
  @Input() images: any;
  @Input() id: any;
  @Input() isPartner: any;
  @Input() pLogo: any;

  inProgress = false;
  message: string;
  fileToUpload: File = null;
  image = new FormControl(null, [Validators.required]);
  logo: any;
  link: any;
  image_name = '';
  constructor(private userService: UserManagerService,
    private helperFunction: HelperFunctions,
    private translate: TranslateService,
    private config: ConfigService,
    public partnerService: PartnerServicesService) { }
  index = 0;
  ngOnInit() {
    // console.log("logos", this.images, this.pLogo)
    this.link = this.config.GATEWAY_IMAGES + '/files/file?filename=';
    this.logo = new FormControl(null, this.isPartner ? [Validators.required] : [Validators.nullValidator]);
    this.image_name = this.isPartner ? "partner_image" : "slidder_image";
  }
  prev() {
    this.index = this.index - 1;
    this.index = this.index < 0 ?
      this.images.length - 1 : this.index;
  }
  next() {
    this.index = this.index + 1;
    this.index = this.index > this.images.length - 1 ?
      0 : this.index;
  }
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }
  uploadFileToActivity() {
    // console.log(!this.images[0].imageUrl, !this.pLogo[0].logo);
    const logo = this.logo.value ? this.logo.value[0] : undefined;
    const image = this.image.value ? this.image.value[0] : undefined;
    if(this.isPartner) this.pLogo.push({logo: logo});
    /* this.images.push(logo);
    this.images.push(image); */
    if (!this.isPartner && image && !this.images[0].imageUrl) {
      return;
    }
    if (this.isPartner && !(logo || this.pLogo[0].logo)) {
      return;
    }
    try {
      this.inProgress = true;
      const params = new FormData();
      if (!this.isPartner) {
        params.append('file', image);
        params.append('alt_text', this.message);
        this.partnerService.uploadPublicationImages(params, this.id).then(res => {
          this.inProgress = false;
          this.partnerService.checkOperation(res);
        }).finally(() => {
          this.inProgress = false;
        });
      } else {
        image ? params.append('image', image) : '';
        logo ? params.append('logo', logo) : '';
        this.partnerService.uploadPartnerImage(params, this.id).then(res => {
          this.inProgress = false;
          this.partnerService.checkOperation(res);
        }).finally(() => {
          this.inProgress = false;
        });
        // tslint:disable-next-line: align
      }
    } catch (err) {
      this.inProgress = false;
    };
  }
  deleteImage(id) {
    const params = {
      image_id: this.images[id].id
    };
    this.partnerService.removePublicationImages(this.id, params).then(res => {
      this.partnerService.checkOperation(res, id);
    });
  }
}

